import {responseTemplatesSuggestionsUrl} from '../../../service/api/api-const';
import {autoReplyFormErrorSchema, AutoReplyFormErrorType} from '../../../service/reviews/reviews-response-templates';
import {deserializeApiError} from '../../../util/api-adapter';
import {ErrorWithStatus, isErrorHasStatusMessage} from '../../../util/error';

export function getAutoReplyFormApiErrorMessage(error: unknown): string | null {
    const parsed = deserializeApiError<AutoReplyFormErrorType>(
        responseTemplatesSuggestionsUrl,
        autoReplyFormErrorSchema,
        error
    );

    const enabledFromMessage = parsed?.enabledFrom?.[0];

    if (enabledFromMessage) {
        return enabledFromMessage;
    }

    if (isErrorHasStatusMessage<ErrorWithStatus>(error)) {
        return error.jsonData.status;
    }

    return null;
}
